import React from "react";

export function PageHeader({ title, subtitle, action, testId }) {
    return (
        <div data-testid={testId} className="flex flex-wrap items-end justify-between gap-3 mb-6">
            <div>
                <h1 className="font-heading text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-foreground">
                    {title}
                </h1>
                {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}

export function Footer() {
    return (
        <footer className="mt-10 border-t border-border pt-5 text-xs text-muted-foreground/70 leading-relaxed">
            Outpost Network is an independent gaming community platform and is not affiliated with or
            endorsed by Facepunch Studios, Double Eleven, Sony, Microsoft, Steam, or their respective affiliates.
        </footer>
    );
}

export function SectionCard({ title, children, action, className = "", testId }) {
    return (
        <div data-testid={testId} className={`tactical-card rounded-lg p-5 ${className}`}>
            {(title || action) && (
                <div className="flex items-center justify-between mb-4">
                    {title && <h3 className="font-heading text-xl font-bold uppercase tracking-wide">{title}</h3>}
                    {action}
                </div>
            )}
            {children}
        </div>
    );
}

export function ComingSoon({ title, icon: Icon }) {
    return (
        <div data-testid="coming-soon" className="tactical-card corner-bracket text-hazard rounded-lg p-10 text-center">
            {Icon && <Icon size={40} className="mx-auto text-hazard mb-4" />}
            <h3 className="font-heading text-2xl font-bold uppercase text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
                This module is wired into the Outpost Network command system and ships in an upcoming phase.
            </p>
        </div>
    );
}
